/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import store, { persistor } from "./redux/store";
import App from "./app/App";
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
// Datepicker
import "react-datepicker/dist/react-datepicker.css";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider
} from "./_metronic/layout";
import {MetronicI18nProvider} from "./_metronic/i18n";
import { initSentry } from "_metronic/_helpers/SentryHelper";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { 
  PUBLIC_URL
} = process.env;

document.addEventListener('DOMContentLoaded', (event) => {
  const hotjarId = process.env.REACT_APP_HOTJAR;
  const scriptContent = `
    !function(t, h, e, j, s, n) {
      t.hj = t.hj || function() {
        (t.hj.q = t.hj.q || []).push(arguments)
      }
      ,
      t._hjSettings = {
        hjid: ${hotjarId},
        hjsv: 6
      },
      s = h.getElementsByTagName("head")[0],
      (n = h.createElement("script")).async = 1,
      n.src = "https://static.hotjar.com/c/hotjar-" + t._hjSettings.hjid + ".js?sv=" + t._hjSettings.hjsv,
      s.appendChild(n)
    }(window, document)
  `;
  const scriptElement = document.createElement('script');
  scriptElement.innerHTML = scriptContent;
  document.head.appendChild(scriptElement);
});
initSentry()

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */



ReactDOM.render(
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <App store={store} persistor={persistor} basename={PUBLIC_URL} />
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>,
  document.getElementById("root")
);
